import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import ListPpv from '../../../pages/ListPpv';
import ListPpvsMobile from '../../MobileComponents/Ppv/ListPpvsMobile';

const ListPpvResponsive = () => {
    const { isMobile } = useResponsiveRedux();
    return isMobile ? <ListPpvsMobile /> : <ListPpv />;
};

export default ListPpvResponsive;